import Header from "./components/Header";
import React, { useContext, useEffect} from "react";
import "./Portfolio.css";
import CardProjeto from "./components/CardProjeto";
import Footer from "./components/Footer"
import PortfolioContext from "./context/PortfolioContext";
import imgCapa from "../src/images/img-capa.jpg";

function Portfolio() {
  const { darkTheme,  setDarkTheme } = useContext(PortfolioContext);
  
  
  useEffect(()=>{
    const exists = localStorage.getItem('theme');
    if (exists) {
      const json = JSON.parse(exists);
      console.log(json);
      setDarkTheme(json)
    }
  },[setDarkTheme])
  


  return (
    <div className={darkTheme? "portfolio-dark": ""}>
      <Header />
      <div className={ darkTheme? "capa-dark":"capa"}>
          <img className="image-capa" src={imgCapa} alt=""/>
          <div className="port-text">
            <h1 className={darkTheme?"port port-text-dark":"port"}>Portfólio</h1>
            <h4 className={darkTheme?"port-h4 port-text-dark":"port-h4"}>conheça meus projetos</h4>
          </div>
      </div>
      <div className="all-cards">
        <CardProjeto/>
        <CardProjeto/>
        <CardProjeto/>
        <CardProjeto/>
        <CardProjeto/>
        <CardProjeto/>
        <CardProjeto/>
        <CardProjeto/>
        </div>
      <Footer />
    </div>
  )
}

export default Portfolio;